/**
* @name: xm-menu-sub
* @description：绿色环保主题子菜单 —— 参考经典模式：子菜单标题内同时放图标+文字，避免折叠弹出时名称被隐藏
*/
<template>
  <a-sub-menu class="xm-menu-sub" :key="menuItem.id">
    <!-- 不使用 #icon 槽：图标+文字都放 #title，折叠弹出时名称才能显示 -->
    <template #title>
      <xm-menu-li
        class="flex-div menu-sub-title-li"
        @click="openMenu"
        :activeItem="isActiveItem(menuItem.id)"
        :openFlag="true"
        :menuItem="menuItem"
      />
    </template>

    <template v-for="sonMenuItem in menuItem.children" :key="sonMenuItem.id || sonMenuItem.path">
      <xm-menu-sub
        v-if="sonMenuItem.type==='menu'"
        :selectedKeys="selectedKeys"
        :openFlag="openFlag"
        :menuItem="sonMenuItem"
      />
      <a-menu-item
        v-if="sonMenuItem.type==='page'"
        :key="String(sonMenuItem.id || sonMenuItem.path)"
        class="el-custom-sidebar-item"
      >
        <template #icon>
          <xm-menu-li
            :activeItem="isActiveItem(String(sonMenuItem.id || sonMenuItem.path))"
            :openFlag="false"
            :menuItem="sonMenuItem"
          />
        </template>
        <span class="menu-title-text" :title="sonMenuItem.label || sonMenuItem.name">
          {{ sonMenuItem.label || sonMenuItem.name }}
        </span>
      </a-menu-item>
    </template>
  </a-sub-menu>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {createAsyncComponent} from "@/utils/factory/createAsyncComponent";

export default defineComponent({
  components: {
    xmMenuSub: createAsyncComponent(() => import('./xm-menu-sub.vue')),
  },
  name: "xm-menu-sub",
});
</script>

<script lang="ts" setup>
import {SubMenu as aSubMenu, MenuItem as aMenuItem} from "ant-design-vue";
import XmMenuLi from "@/layouts/layoutFrame/scaLayout/components/xm-menu-li.vue";

interface IProps {
  pItem?: any,
  menuItem: any,
  openFlag: boolean,
  selectedKeys: any
}

const props = withDefaults(defineProps<IProps>(), {
  menuItem: {},
  pItem: {},
  openFlag: false,
  selectedKeys: () => [],
});
const {selectedKeys} = toRefs(props);

const isActiveItem = function (key) {
  return !!unref(selectedKeys).filter((itemDb) => key === itemDb)[0];
}

const emits = defineEmits(['openMenu']);
const openMenu = function () {
  emits("openMenu", props.menuItem, props.pItem);
}
</script>

<style type="text/css" lang="less">
.xm-menu-sub {
  .menu-sub-title-li.el-custom-sidebar-icon-container {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    overflow: hidden;

    .item-icon {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .open-item-label {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
